import { render, staticRenderFns } from "./distributionProducts.vue?vue&type=template&id=28306456&scoped=true&"
import script from "./distributionProducts.vue?vue&type=script&lang=js&"
export * from "./distributionProducts.vue?vue&type=script&lang=js&"
import style0 from "./distributionProducts.vue?vue&type=style&index=0&id=28306456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28306456",
  null
  
)

component.options.__file = "distributionProducts.vue"
export default component.exports